import { BaseForm } from '@app/components/common/forms/BaseForm/BaseForm';
import { FONT_WEIGHT } from '@app/styles/themes/constants';
import { List } from 'antd';
import styled from 'styled-components';

export const ListItem = styled(List.Item)`
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border-radius: 8px;
  margin: 8px 0;
  padding: 8px 12px;
  cursor: pointer;

  &.selected {
    background: #e6f7ff;
  }
`;

export const ChatWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex: 1;
`;

export const BlankDiv = styled.div``;

export const ItemText = styled.div`
  font-weight: 600;
`;

export const ItemSubText = styled.div`
  font-size: 12px;
  color: #888;
`;

export const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const BaseFormWrapper = styled(BaseForm)`
  .ant-form-item-label label {
    width: 100%;
  }
`;

export const ActionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: flex-end;
`;

export const Link = styled.a`
  text-decoration: underline;
  cursor: pointer;
  font-weight: ${FONT_WEIGHT.medium};
  word-break: break-all;
  &:hover {
    text-decoration: none;
  }
`;

export const PreviewContainer = styled(BaseForm.Item)`
  background: #f5f5f5;
  border-radius: 8px;
  padding: 12px 16px;
`;

export const PreviewWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  &.border-top {
    border-top: 1px solid #e9e9e7;
    padding-top: 12px;
    margin-top: 12px;
  }
`;

export const PreviewHeader = styled.div`
  font-weight: 500;
  font-size: 16px;
  min-width: 70px;
  width: max-content;
  color: var(--primary-color);
  display: flex;
  justify-content: center;
  width: 100%;
  align-items: center;
  padding-bottom: 12px;
  margin-bottom: 12px;
  border-bottom: 1px solid #e9e9e7;
`;

export const PreviewTitle = styled.div`
  font-weight: 500;
  font-size: 14px;
  min-width: 70px;
  width: max-content;
  color: var(--primary-color);
`;

export const PreviewDescription = styled.div`
  font-weight: 500;
  font-size: 14px;
`;
